import { Component, OnInit, OnDestroy } from '@angular/core';
import { RosterItem } from '../models/rosteritem.model';
import { ProfileService } from '../profile.service';
import { Subscription } from 'rxjs';
import { SearchResult } from 'src/app/search/models/searchresult.model';
import { DataService } from 'src/app/shared/data.service';
declare var $: any;

@Component({
  selector: 'app-individual-profile',
  templateUrl: './individual-profile.component.html',
  styleUrls: ['./individual-profile.component.css']
})
export class IndividualProfileComponent implements OnInit, OnDestroy {
  individual: SearchResult = new SearchResult("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", false, false, false, false, "", "", 0, "", "", "", "", "", "");
  individualSubscription: Subscription;
  constructor(private profileService: ProfileService, private dataService: DataService) { }

  ngOnInit() {
    this.individualSubscription = this.profileService.currentIndividualProfileLoaded
      .subscribe(
        (result: SearchResult) => {
          this.individual = result;
          $('#individualModal').modal('show');
          setTimeout(() => {
            $('#individualprofileview [data-toggle="tooltip"]').tooltip('dispose');
            $('#individualprofileview [data-toggle="tooltip"]').tooltip({ html: true });
          }, 500);
        }
      );
  }
  showCompany() {
    if (this.profileService.currentCompany != null && this.profileService.currentCompany.Id === this.individual.CoId) {
      $('#individualModal').modal('hide');
    } else {
      setTimeout(() => {
        $(".modal").modal('hide');
      }, 300);

      this.dataService.getSearchResults(this.individual.CoId, "Id", "", "", 50);
    }
  }
  ngOnDestroy() {
    this.individualSubscription.unsubscribe();
  }
  getCleanPhoneForLink() {
    return "1" + this.individual.Phone.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }

  getCleanTollFreeForLink() {
    return "1" + this.individual.TollFree.replace("(", "").replace(")", "").replace("-", "").replace(" ", "")
  }
}
